import { render, staticRenderFns } from "./prices-tests.vue?vue&type=template&id=d4eb5fb2"
import script from "./prices-tests.vue?vue&type=script&lang=js"
export * from "./prices-tests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports